export default __webpack_public_path__ + "../img/a62760c2e2017933a16b60c1674702a1.png";